// @flow

type OwnProps = {};
const RideBoarded = (props: OwnProps) => {
    //Boarded currently just show the map
    return null;
};
export default RideBoarded;



// WEBPACK FOOTER //
// ./src/Components/Screen/Ride/RideBoarded/RideBoarded.js